<script setup lang="ts">
import { computed } from "vue";
import { TextContent } from "../../../types/localMessage";

const props = defineProps<{
  content: TextContent[];
}>();

function correctLink(link: string) {
  return link.includes("//") ? link : "//" + link;
}
const emojiOnly = computed(() => {
  try {
    const emojiRegex = new RegExp("^(?:\\p{RGI_Emoji})+$", "v");
    const res =
      props.content.length === 1 && emojiRegex.test(props.content[0].content);
    return res;
  } catch {
    return false;
  }
});
</script>
<template>
  <span>
    <template v-for="(item, id) in content" :key="id">
      <span
        class="text font-with-emoji"
        :class="{ emojiOnly }"
        v-if="item.type === 'text'"
        >{{ item.content }}</span
      >
      <a
        v-else-if="item.type === 'link'"
        :href="correctLink(item.content)"
        target="_blank"
        >{{ item.content }}</a
      >
      <a
        v-else-if="item.type === 'mail'"
        :href="`mailto:${item.content}`"
        target="_blank"
        >{{ item.content }}</a
      >
    </template>
  </span>
</template>
<style scoped>
a,
a:active {
  color: #7ec8dd;
  text-decoration: none;
}

a:hover {
  color: #7ec8dd;
  text-decoration: underline;
}

.text {
  color: #ffffff;
  font-size: 14px;
  font-weight: 400;
}

.emojiOnly {
  font-size: 24px;
  line-height: 32px;
  word-break: break-word;
}
</style>
